"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ILtLogo", {
  enumerable: true,
  get: function get() {
    return _types.ILtLogo;
  }
});
Object.defineProperty(exports, "IPartnerLogo", {
  enumerable: true,
  get: function get() {
    return _types.IPartnerLogo;
  }
});
Object.defineProperty(exports, "PartnerLogo", {
  enumerable: true,
  get: function get() {
    return _PartnerLogo["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LtLogo["default"];
  }
});
var _LtLogo = _interopRequireDefault(require("./LtLogo"));
var _PartnerLogo = _interopRequireDefault(require("./PartnerLogo"));
var _types = require("./types");